import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100 row overflow-hidden" }
const _hoisted_2 = { class: "required fs-6 fw-semobold mb-2 mt-4" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "ms-5" }
const _hoisted_5 = { class: "required fs-6 fw-semobold mb-2 mt-4" }
const _hoisted_6 = { class: "required fs-6 fw-semobold mb-2 mt-4" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { class: "ms-5" }
const _hoisted_9 = { class: "required fs-6 fw-semobold mb-2 mt-4" }
const _hoisted_10 = { class: "mb-5" }
const _hoisted_11 = { class: "required fs-6 mb-4" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = {
  key: 0,
  class: "fa-regular fa-xl fa-circle-check ms-3",
  style: {"color":"#14a44d"}
}
const _hoisted_14 = {
  key: 1,
  class: "fa-regular fa-xl fa-circle-xmark ms-3",
  style: {"color":"#900000"}
}
const _hoisted_15 = { class: "required fs-6 mb-4" }
const _hoisted_16 = { class: "mb-5" }
const _hoisted_17 = { class: "required fs-6 mb-4" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = {
  key: 0,
  class: "fa-regular fa-xl fa-circle-check ms-3",
  style: {"color":"#14a44d"}
}
const _hoisted_20 = {
  key: 1,
  class: "fa-regular fa-xl fa-circle-xmark ms-3",
  style: {"color":"#900000"}
}
const _hoisted_21 = { class: "required fs-6 mb-4" }

import { inject, ref } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import { AccountRoleTypes } from "@/core/types/AccountInfos";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditSalesAndAgentModal',
  emits: ["update"],
  setup(__props, { expose: __expose, emit: emits }) {


const isLoading = ref(true);

const ibGroupExist = ref(false);
const salesCodeExist = ref(false);

const modalRef = ref<InstanceType<typeof SimpleForm>>();
const formData = ref({} as any);
const accountDetails = ref({} as any);

const newAgentAccount = ref({} as any);
const newSalesAccount = ref({} as any);
const show = async (details: any) => {
  const res = await AccountService.queryAccounts({ id: details.id });
  accountDetails.value = res.data[0];
  console.log({ ...accountDetails.value });
  formData.value.group = accountDetails.value.group;
  formData.value.code = accountDetails.value.code;
  formData.value.salesName = accountDetails.value.salesAccount.name || "***";
  formData.value.agentName = accountDetails.value.agentAccount.name || "***";
  modalRef.value?.show();
  isLoading.value = false;
  // formData.value.group = accountDetails.modalRef.value?.show();
};

const newAgentInfoRef = ref<InstanceType<typeof SimpleForm>>();
const newSalesInfoRef = ref<InstanceType<typeof SimpleForm>>();

const newAgentInfo = async () => {
  newAgentInfoRef.value?.show();
};

const newSalesInfo = async () => {
  newSalesInfoRef.value?.show();
};

const getIbAccountInfo = async () => {
  if (!newAgentAccount.value.group || newAgentAccount.value.group === "")
    return;
  try {
    const res = await AccountService.queryAccounts({
      group: newAgentAccount.value.group,
      role: AccountRoleTypes.IB,
    });

    if (res.data.length > 1 || res.data.length == 0) {
      newAgentAccount.value.name = "";
      ibGroupExist.value = false;
      return;
    }

    const account = res.data[0];
    newAgentAccount.value.name =
      account.name || "IB account valid but has no name";
    newAgentAccount.value.code = account.code;
    newAgentAccount.value.agentId = account.id;
    ibGroupExist.value = true;
  } catch (e) {
    console.log(e);
    newAgentAccount.value.name = "";
    newAgentAccount.value.code = "";
    ibGroupExist.value = false;
  }
};

const getSalesAccountInfo = async () => {
  if (!newSalesAccount.value.code || newSalesAccount.value.code === "") return;
  try {
    const res = await AccountService.queryAccounts({
      code: newSalesAccount.value.code,
      role: AccountRoleTypes.Sales,
    });

    if (res.data.length > 1 || res.data.length == 0) {
      newSalesAccount.value.name = "";
      salesCodeExist.value = false;
      return;
    }

    const account = res.data[0];
    newSalesAccount.value.name =
      account.name || "Sales account valid but has no name";
    newSalesAccount.value.code = account.code;
    newSalesAccount.value.salesId = account.id;
    salesCodeExist.value = true;
  } catch (e) {
    console.log(e);
    newSalesAccount.value.name = "";
    newSalesAccount.value.code = "";
    salesCodeExist.value = false;
  }
};

const submit = async () => {
  if (newAgentAccount.value.group === accountDetails.value.group) {
    MsgPrompt.info("New IB group is the same as the old one");
    return;
  }
  try {
    await AccountService.changeAgentGroup(
      accountDetails.value.id,
      newAgentAccount.value.agentId
    );
    emits("update");
    newAgentInfoRef.value?.hide();
    modalRef.value?.hide();
  } catch (e) {
    MsgPrompt.error(e);
  }
};

const submitSalesChange = async () => {
  if (newSalesAccount.value.code === accountDetails.value.code) {
    MsgPrompt.info("New Sales group is the same as the old one");
    return;
  }
  try {
    await AccountService.changeSalesGroup(
      accountDetails.value.id,
      newSalesAccount.value.salesId
    );
    emits("update");
    newSalesInfoRef.value?.hide();
    modalRef.value?.hide();
  } catch (e) {
    MsgPrompt.error(e);
  }
};

const openConfirmBoxHandler = inject(
  TenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL
);
const openConfirmBoxModal = async () => {
  try {
    const res = await AccountService.queryAccounts({
      group: accountDetails.value.group,
      role: AccountRoleTypes.IB,
    });
    const currentAgentAccount = res.data[0];

    openConfirmBoxHandler?.(() =>
      AccountService.removeAgentGroup(
        accountDetails.value.id,
        currentAgentAccount.id
      )
        .then(() => {
          emits("update");
          modalRef.value?.hide();
        })
        .catch((e) => MsgPrompt.error(e))
    );
  } catch (e) {
    MsgPrompt.error("Current agent account not found");
  }
};

__expose({
  show,
  hide: () => modalRef.value?.hide(),
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('title.changeSalesOrIb'),
    "is-loading": isLoading.value,
    width: 450,
    "disable-footer": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("fields.salesCode")), 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    disabled: "",
                    modelValue: formData.value.code,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.code) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: newSalesInfo
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.change")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("fields.salesInfo")), 1),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  disabled: "",
                  modelValue: formData.value.salesName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.salesName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_divider),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("fields.ibGroup")), 1),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    disabled: "",
                    modelValue: formData.value.group,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.group) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: newAgentInfo
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.change")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: openConfirmBoxModal }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.remove")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("fields.ibInfo")), 1),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  disabled: "",
                  modelValue: formData.value.agentName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.agentName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(SimpleForm, {
          ref_key: "newAgentInfoRef",
          ref: newAgentInfoRef,
          title: _ctx.$t('fields.newIbGroup'),
          disableSubmit: !ibGroupExist.value,
          "is-loading": false,
          submit: submit,
          width: "300"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("fields.newIbGroup")), 1),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_form_item, { style: {"margin":"0"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: newAgentAccount.value.group,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newAgentAccount.value.group) = $event)),
                        onKeyup: getIbAccountInfo
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                (ibGroupExist.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                  : (_openBlock(), _createElementBlock("i", _hoisted_14))
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("fields.name")), 1),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    disabled: "",
                    modelValue: newAgentAccount.value.name,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newAgentAccount.value.name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["title", "disableSubmit"]),
        _createVNode(SimpleForm, {
          ref_key: "newSalesInfoRef",
          ref: newSalesInfoRef,
          title: _ctx.$t('fields.newSalesCode'),
          disableSubmit: !salesCodeExist.value,
          "is-loading": false,
          submit: submitSalesChange,
          width: "300"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("fields.newSalesCode")), 1),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_form_item, { style: {"margin":"0"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: newSalesAccount.value.code,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newSalesAccount.value.code) = $event)),
                        onKeyup: getSalesAccountInfo
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                (salesCodeExist.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                  : (_openBlock(), _createElementBlock("i", _hoisted_20))
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("fields.name")), 1),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    disabled: "",
                    modelValue: newSalesAccount.value.name,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((newSalesAccount.value.name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["title", "disableSubmit"])
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})